var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestore = function SvgRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.111 13.778s.108.755 3.232 3.879a8 8 0 0 0 13.458-3.88m-16.69 0v5.334m0-5.333h5.334m12.444-3.556s-.108-.755-3.232-3.879A8 8 0 0 0 4.2 10.223m16.69 0V4.888m0 5.333h-5.333"
  })));
};
export default SvgRestore;